import Swal from 'sweetalert2';

const lang = document.documentElement.lang;

const tr = {
  'pt-BR': {
    modal_warning_soon: 'Em breve!',
  },
  en: {
    modal_warning_soon: 'Coming soon!',
  },
  es: {
    modal_warning_soon: '¡Muy pronto!',
  },
};

const $closed_mission = document.querySelectorAll('[data-warning]');

function closedMission() {
  $closed_mission.forEach(el => {
    el.addEventListener('click', ev => {
      ev.preventDefault();
      Swal.fire(tr[lang].modal_warning_soon, '', 'warning');
    });
  });
}

export { closedMission };
